import btnStyle from '@/components/Shares/Button.module.css';
import { DIALOG } from '@/types';
import { useLingui } from '@lingui/react';
import { Button } from '@mantine/core';
import { IconPlus } from '@tabler/icons-react';
export type InfoAddPaymentButtonProps = {
  setOpenDialog: (modal: DIALOG | null) => void;
};
export const InfoAddPaymentButton: React.FC<InfoAddPaymentButtonProps> = ({
  setOpenDialog
}) => {
  const {
    i18n
  } = useLingui();
  const handleAddPayment = () => {
    setOpenDialog(DIALOG.ADD_PAYMENT);
  };
  return <Button px={0} h={40} w={152} mt={20} fz="xs" onClick={handleAddPayment} leftSection={<IconPlus size={24} />} classNames={{
    root: btnStyle.button_style_2,
    section: btnStyle.btnSection
  }}>
      {i18n._('Add New Card')}
    </Button>;
};